import { ToastIntent, useToastController } from "@fluentui/react-components";
import { ReactNode, useCallback } from "react";

export const useToastNotification = () => {
  const toasterId = "notification-toaster";
  const { dispatchToast, dismissToast } = useToastController(toasterId);

  const notify = useCallback(
    (toastElFactory: (id: string) => ReactNode, intent: ToastIntent) => {
      const id = crypto.randomUUID();
      const element = toastElFactory(id);
      dispatchToast(element, {
        intent,
        politeness: intent === "error" ? "assertive" : "polite",
        toastId: id,
      });
    },
    [dispatchToast]
  );

  const dismissNotification = useCallback(
    (id: string) => {
      dismissToast(id);
    },
    [dismissToast]
  );

  return { toasterId, notify, dismissNotification };
};
